import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {APPCONFIG} from '../../config';

@Component({
  selector: 'my-page-404',
  styles: [],
  templateUrl: './404.component.html',
  standalone: false,
})
export class Page404Component implements OnInit {
  constructor(private titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle('Error 404 | ' + APPCONFIG.pageTitle);
  }
}
